export default __webpack_public_path__ + "static/media/Samsung Galaxy Note20.ff71d4da.png";